<template>
    <div class="spo-card rounded bordered pa-2 d-flex flex-column ga-2">
        <div class="text-h6 font-weight-bold text-darkblue">Filtrer les participants</div>

        <!-- Filtre Courses -->
        <div class="d-flex flex-column">
            <label class="field_label">Par courses</label>
            <div class="text-subtitle-2">Si aucune course n'est sélectionnée, ce filtre sera
                ignoré.</div>
            <v-select v-model="selectedCourses" :items="coursesOptions" item-title="name" item-value="id" multiple chips
                closable-chips density="comfortable">

            </v-select>
        </div>

        <!-- Filtre Options -->
        <div class="d-flex flex-column">
            <label class="field_label">Par options</label>
            <div class="text-subtitle-2">Si aucune option n'est sélectionnée, ce filtre sera
                ignoré.</div>
            <v-select v-model="selectedOptions" :items="optionsOptions" item-title="name" item-value="id" multiple chips
                closable-chips density="comfortable">

            </v-select>
        </div>
    </div>
</template>

<script>
import { useMailingSystemStore } from "@/stores/mailingSystem/mailingSystemStore";
import { mapStores } from "pinia";
export default {
    data() {
        return {
            selectedCourses: [],
            selectedOptions: [],
        }
    },
    computed: {
        ...mapStores(useMailingSystemStore),
        filtersReady() {
            return this.mailingSystemStore.filtersContactListing !== null;
        },
        coursesFilter() {
            if (!this.filtersReady) return null;
            return this.mailingSystemStore.filtersContactListing.find(f => f.name === 'courses');
        },
        optionsFilter() {
            if (!this.filtersReady) return null;
            return this.mailingSystemStore.filtersContactListing.find(f => f.name === 'options');
        },
        coursesOptions() {
            return this.coursesFilter ? this.coursesFilter.options : [];
        },
        optionsOptions() {
            return this.optionsFilter ? this.optionsFilter.options : [];
        },
        allCoursesSelected() {
            return this.selectedCourses.length === this.coursesOptions.length;
        },
        someCoursesSelected() {
            return this.selectedCourses.length > 0;
        },
        allOptionsSelected() {
            return this.selectedOptions.length === this.optionsOptions.length;
        },
        someOptionsSelected() {
            return this.selectedOptions.length > 0;
        }
    },
    methods: {
        toggleAllCourses() {
            if (this.allCoursesSelected) {
                this.selectedCourses = [];
            } else {
                this.selectedCourses = this.coursesOptions.map(c => c.id);
            }
        },
        toggleAllOptions() {
            if (this.allOptionsSelected) {
                this.selectedOptions = [];
            } else {
                this.selectedOptions = this.optionsOptions.map(o => o.id);
            }
        },
        initializeSelections() {
            // Initialiser avec toutes les courses sélectionnées par défaut
            this.selectedCourses = this.coursesOptions
                .filter(c => c.selected)
                .map(c => c.id);

            // Initialiser avec toutes les options sélectionnées par défaut
            this.selectedOptions = this.optionsOptions
                .filter(o => o.selected)
                .map(o => o.id);
        },
        fetchContactList() {
            const filters = {
                courses: this.selectedCourses,
                options: this.selectedOptions
            };
            this.mailingSystemStore.fetchFilteredInscriptionsList(filters);

        }
    },
    watch: {
        selectedCourses: {
            handler() {
                this.fetchContactList();
            },
            deep: true
        },
        selectedOptions: {
            handler() {
                this.fetchContactList();
            },
            deep: true
        }
    },
    mounted() {
        this.mailingSystemStore.initFiltersContactListingFromModule();
        this.$nextTick(() => {
            this.initializeSelections();
            this.fetchContactList();
        });
    }
}
</script>

<style lang="scss" scoped></style>